<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1250px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="hrissecondary"
        class="white--text"
        block
        v-on="on"
      >
        Create Leave Entitlement
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Leave Entitlement"
      text="Create Leave Entitlement"
      class="mb-0"
    > 
      <v-container v-if="dialog">
        <v-row>
          <v-col
            :key="componentKey"
            cols="4"
            class="form-overflow"
            data-simplebar
          >
            <v-autocomplete 
              v-model="selectedLeaveTypes"
              placeholder="Choose a leave type"
              :items="leaveTypes"
              item-text="name"
              return-object
              label="Leave Type"
              multiple
              hide-selected
              autofocus
              @change="addEntitlement()"
            >
              <template v-slot:selection="data">
                <v-chip
                  :input-value="data.selected"
                  close
                  class="chip--select-multi"
                  @click:close="removeEntitlement(data.item)"
                >
                  {{ data.item.name }}
                </v-chip>
              </template>
            </v-autocomplete>
            <v-card
              v-for="(entitlement, index) in form"
              :key="index"
              class="pl-4 pr-4 mb-4 elevation-5"
            >
              <v-form>
                <p
                  v-if="form[index].year === null"
                  class="pt-3 subtitle-1"
                  v-text="form[index].name"
                />
                <p
                  v-else
                  class="pt-3 subtitle-1"
                  v-text="form[index].name + ' (' + form[index].year + ')'"
                />
                <v-text-field
                  :key="index"
                  v-model="form[index].entitledDays"
                  v-validate="'required|negativeValue|nearestZeroPointFive'"
                  :error-messages="errors.collect('entitled_days' + index)"
                  :name="'entitled_days' + index"
                  data-vv-as="Entitled Days"
                  type="number"
                  label="Entitled Days"
                  :min="0"
                  @keydown.native="['e', 'E', '+', '-'].includes($event.key) && $event.preventDefault()"
                />
              </v-form>
            </v-card>
          </v-col>
          <v-col cols="8">
            <v-card class="pa-4 elevation-5">
              <v-text-field
                v-model="searchInput"
                placeholder="Filter employee by name"
                append-icon="search"
                label="Search Employee"
                hide-no-data
                hide-selected
              />
              <v-autocomplete
                v-model="filters.states"
                :items="states"
                item-text="name"
                item-value="id"
                value="id"
                label="State of Work"
                placeholder="Filter employee by state"
                clearable
                hide-selected
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="remove('states', data.item)"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="filters.positions"
                :items="positions"
                item-text="label"
                item-value="id"
                value="id"
                label="Position"
                placeholder="Filter employee by position"
                clearable
                hide-selected
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="remove('positions', data.item)"
                  >
                    {{ data.item.label }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-model="filters.departments"
                :items="departments"
                item-text="name"
                item-value="id"
                value="id"
                label="Department"
                placeholder="Filter employee by department"
                clearable
                hide-selected
                multiple
              >
                <template v-slot:selection="data">
                  <v-chip
                    :input-value="data.selected"
                    close
                    class="chip--select-multi"
                    @click:close="remove('departments', data.item)"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
              </v-autocomplete>
              <v-data-table
                v-model="selectedEmployees"
                dense
                :loading="tableLoading"
                :headers="headers"
                :items="filteredEmployees"
                item-key="employee_uid"
                hide-default-footer
                fixed-header
                disable-pagination
                item-value="employee_uid"
                show-select
                class="elevation-1 mb-3"
                height="335px"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    color="white"
                  >
                    <v-toolbar-title>Employee Selection:</v-toolbar-title>
                  </v-toolbar>
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      
      <v-card-actions>  
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"  
          class="px-10 white--text"        
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        advanceFilter: false,
        componentKey: 0,
        dateMenu: false,
        dialog: false,
        employees: [],
        filters: {
          states: '',
          positions: '',
          departments: '',
        },
        form: [
        ],
        hintText: 'It will automatically set to end of the month',
        headers: [
          {
            text: 'Name',
            align: 'left',
            sortable: true,
            value: 'user.name',
          },
          {
            text: 'Position',
            align: 'left',
            sortable: true,
            value: 'current_position.position.name',
          },
          {
            text: 'State',
            align: 'left',
            sortable: true,
            value: 'city.state.name',
          },        
        ],
        leaveTypes: [],
        monthMenu: false,
        positions: [],
        progressing: false,
        searchInput: '',
        selectedEmployees: [],
        selectedLeaveTypes: [],
        tableLoading: false,  
        states: [],
        departments: [],
      }
    },
    computed: {
      earliestDate () {
        return this.$moment().year() + '-01-01'
      },
      earliestMonth () {
        return this.$moment().year() + '-01'
      },
      latestDate () {
        return this.$moment().year() + '-12-31'
      },
      latestMonth () {
        return this.$moment().year() + '-12'
      },
      filteredEmployees () {
        let _this = this
        _this.searchInput = _this.searchInput.trim()
        let primaryFilterEmployees = this.employees.filter(function (employee) {
          return ((employee.user || {}).name || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1 ||
            ((employee.user || {}).username || '').toLowerCase().indexOf(_this.searchInput.toLowerCase()) !== -1
        })
        let filteredPositions = this.customFilterPositions(primaryFilterEmployees)
        let filteredStates = this.customFilterStates(filteredPositions)
        let filteredDepartments = this.customFilterDepartments(filteredStates)

        return filteredDepartments
      },
    },
    watch: {
      dialog (value) {
        if (value) {
          this.loadData()
        } else {
          this.$resetData()
        }
      },
    },
    mounted () {
      let scope = this

      this.$validator.extend('negativeValue', {
        getMessage (field, args) {
          return 'Invalid Number'
        },
        validate (value, args) {
          return scope.isValidNumbers(value)
        },
      })

      this.$validator.extend('nearestZeroPointFive', {
        getMessage (field, args) {
          return 'Please enter days to the nearest 0.5'
        },
        validate (value, args) {
          return scope.isTheNearestZeroPointFiveNumbers(value)
        },
      })
    },
    methods: {
      loadData () {
        this.tableLoading = true

        this.$api.adminStateEmployees().list('')
          .then(response => {
            this.employees = response.data
            this.tableLoading = false
          })
          .catch(() => {})

        this.$api.positions().list()
          .then(response => {
            this.positions = response.data.map(pos => ({
              id: pos.id,
              label: `${pos.name} (${pos.job_grade.job_group.name})`,
            }))
          })
          .catch(() => {})

        this.$api.hrisDepartments().list()
          .then(response => {
            this.departments = response.data
          })
          .catch(() => {})
        
        this.$api.states().list()
          .then((res) => {
            this.states = res.data
          })
          .catch(() => {})

        this.$api.hrisLeaveTypes().list()
          .then(response => {
            this.leaveTypes = response.data.filter(leaveType => {
              return leaveType.is_optional_leave_entitlement === 1 && (!leaveType.expiry_date || leaveType.expiry_date > this.$moment().format('YYYY-MM-DD'))
            })
          })
          .catch(() => {})
      },
      customFilterPositions (employeesList) {
        if (this.filters.positions.length === 0) return employeesList

        return employeesList.filter(employee => {
          let positionId = (employee.current_position || {}).position_id

          return _.intersection([positionId], this.filters.positions).length > 0
        })
      },
      customFilterStates (employeesList) {
        if (this.filters.states.length === 0) return employeesList

        return employeesList.filter(employee => {
          let stateId = (employee.city || {}).state_id

          return _.intersection([stateId], this.filters.states).length > 0
        })
      },
      customFilterDepartments (employeesList) {
        if (this.filters.departments.length === 0) return employeesList

        return employeesList.filter(employee => {
          let departmentId = (employee || {}).department_id

          return _.intersection([departmentId], this.filters.departments).length > 0
        })
      },
      addEntitlement () {
        let leaveExpiryDate = this.selectedLeaveTypes[this.selectedLeaveTypes.length - 1].expiry_date
        this.form.push(
          {
            name: this.selectedLeaveTypes[this.selectedLeaveTypes.length - 1].name,
            leaveTypeId: this.selectedLeaveTypes[this.selectedLeaveTypes.length - 1].id,
            year: (new Date()).getFullYear(),
            startDate: this.$moment().startOf('year').format('YYYY-MM-DD'),
            entitledDays: 0,
            expiryDate: null,
            maxCarryForwardAmount: null,
            leaveExpiryDate: leaveExpiryDate && (leaveExpiryDate <= this.$moment().endOf('year').format('YYYY-MM-DD')) ? leaveExpiryDate : null,
          },
        )
        
        this.rerender()
      },
      rerender () {
        this.componentKey++ // To force the component to re-render due to data-simplebar bug
      },
      removeEntitlement (item) {
        let index = this.selectedLeaveTypes.findIndex(selectedId => selectedId.id === item.id)

        if (index >= 0) {
          this.selectedLeaveTypes.splice(index, 1)
          this.form.splice(index, 1)
        }
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.leaveEntitlements().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created')             
                  this.$snack({ message: 'Leave Entitlements Created' })

                  this.dialog = false               
                }
              }).catch((e) => {
                if (e.response.data.errors.year) {
                  this.$snack({
                    color: 'error',
                    message: (e.response.data.errors.year).toString(), 
                  })
                } else {
                  this.$snack({ 
                    color: 'error',
                    message: 'Failed to create leave entitlement', 
                  })
                }
              }).then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        let entitlementsList = []
        let employeesList = []
        let expiryDate = null
        this.selectedEmployees.forEach((employee) => {
          let tempEmployee = {
            employee_uid: employee.employee_uid,
          }
          employeesList.push(tempEmployee)
        })
        this.form.forEach((entitlement) => {
          if (entitlement.expiryDate !== null) {
            expiryDate = this.$moment(entitlement.expiryDate).endOf('month').format('YYYY-MM-DD')
          } else if (entitlement.maxCarryForwardAmount === null) {
            expiryDate = null
          }
          let tempEntitlement = {
            leave_type_id: entitlement.leaveTypeId,
            year: entitlement.year,
            start_date: entitlement.startDate,
            entitled_days: entitlement.entitledDays,
            carried_forward_expiry_date: expiryDate,
            maximum_carry_forward_amount: entitlement.maxCarryForwardAmount,
            end_date: entitlement.leaveExpiryDate,
          }
          entitlementsList.push(tempEntitlement)
        })
        return {
          employees: employeesList,
          entitlements: entitlementsList,
        }
      },
      isValidNumbers (value) {
        return value >= 0
      },
      isTheNearestZeroPointFiveNumbers (value) {
        return value % 0.5 === 0
      },
      remove (key, item) {
        let index = this.filters[key].findIndex(selectedId => selectedId === item.id)

        if (index >= 0) this.filters[key].splice(index, 1)
      },
    },
  }
</script>

<style lang="css" scoped>
  .form-overflow {
    height: 70vh;
  }
</style>
